import { t } from '@lingui/macro';
import React, { FocusEventHandler } from 'react';
import { InputDialog } from 'components/dialogs/InputDialog';
import { OverlayProps } from 'components/TaskOverlay';

export type RenameHandler = (newName: string, onComplete: () => void) => void;

interface RenameDialogProps extends OverlayProps {
  currentName: string;
  onRename: RenameHandler;
  isRenaming: boolean;
}

export const RenameDialog = ({
  currentName,
  isOpen,
  onClose,
  onRename,
  isRenaming,
}: RenameDialogProps) => {
  const onSubmit = (newAttachmentName: string) => {
    onRename(newAttachmentName, onClose);
  };
  const onFocus: FocusEventHandler<HTMLInputElement> = (event) => {
    let lastDotIndex = event.target.value.lastIndexOf('.');
    lastDotIndex =
      lastDotIndex === -1 ? event.target.value.length : lastDotIndex;
    event.target.setSelectionRange(0, lastDotIndex);
  };

  return (
    <InputDialog
      title={t`Rename`}
      submitButtonLabel={t`Rename`}
      defaultValue={currentName}
      onClose={onClose}
      isOpen={isOpen}
      isLoading={isRenaming}
      onSubmitInput={onSubmit}
      onFocus={onFocus}
      data-qa="rename-dialog"
      validation={{
        nameTooLong: (name: string) =>
          name.length < 256 ||
          t`Names cannot be longer than 255 characters. Please retry with a shorter name.`,
      }}
    />
  );
};
